import React, { FunctionComponent, SVGAttributes } from 'react'
import { Button, Image } from '@deal/components'
import PageContent from '#src/components/PageContent'
import { CreatePathFlowInput } from '#src/generated/graphql'
import jet from './jet.png'
import Experts from './experts.svg'
import Free from './free.svg'
import styles from './styles.css'

interface Item {
  title: string
  subtitle: string
  iconURL?: string
  icon?: FunctionComponent<SVGAttributes<SVGElement>>
}

interface Props {
  title: string
  items: Item[]
  buttonText?: string
  onSubmit?: (prefillData?: CreatePathFlowInput) => void
}

const JetsLowestPrice: React.SFC<Props> = ({ onSubmit, title, items, buttonText }) => (
  <div className={styles.section}>
    <PageContent>
      <div className={styles.title}>{title}</div>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <div className={styles.listContainer}>
            {items.map(({ title, subtitle, iconURL, icon: Icon }) => (
              <div key={title} className={styles.listItem}>
                {iconURL ? (
                  <Image src={iconURL} className={styles.listImage} />
                ) : Icon ? (
                  <Icon className={styles.listImage} />
                ) : null}
                <div>
                  <div className={styles.listTitle}>{title}</div>
                  <div className={styles.listText}>{subtitle}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Image src={jet} className={styles.rightImage} />
      </div>
      {onSubmit && (
        <div className={styles.footerContainer}>
          <Button
            className={styles.button}
            onClick={() => onSubmit()}
            size="large"
            variant="primary-outline"
          >
            <Experts />
            {buttonText || 'Get expert assistance'}
          </Button>
          <Free className={styles.footerImage} />
        </div>
      )}
    </PageContent>
  </div>
)

export default JetsLowestPrice
